module.exports = __webpack_public_path__ + "static/assets/c682adf6b6f38c8fc43376c1cdb5654f.png";